module.exports = __webpack_public_path__ + "img/download-active.5170a749.svg";